import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService, UserService } from '../../services';
import { AuthStatusObject } from 'src/app/shared';
import { AnimationOptions } from 'ngx-lottie';
import { authFade } from '../_auth-animation';
import { UserSchema } from '../../models';
import { IsLoadingService } from '@service-work/is-loading';
import { IS_SERVER_PLATFORM } from '../../../core/constant';

export type AuthInnerRouterParams = 'login' | 'register' | 'activation';

@Component({
  selector: 'app-auth-form',
  templateUrl: './auth-form.component.html',
  styleUrls: ['./auth-form.component.scss'],
  animations: [authFade],
})
export class AuthFormComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  private set subscriptions(subscription: Subscription | undefined) {
    if (subscription) {
      this._subscriptions.push(subscription);
    }
  }
  private _innerRouterState!: AuthInnerRouterParams;
  otp = false;

  constructor(
    private snackbar: MatSnackBar,
    private authService: AuthService,
    private userService: UserService,
    private isLoadingService: IsLoadingService,
    @Inject(IS_SERVER_PLATFORM) private isServer: boolean,
    public dialogRef: MatDialogRef<AuthFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData?: any
  ) {}

  async ngOnInit() {
    this._innerRouter$ = new BehaviorSubject(
      this?.dialogData?.route || 'login'
    );

    this.subscriptions = this.authService.authStatus.subscribe((status) => {
      if (status?.isOk && status?.type === 'google-auth') {
        this.dialogRef.close(status);
      }
    });

    this.subscriptions = this.userService.status$.subscribe((statusObject) => {
      if (statusObject?.status === 'update' && statusObject?.payload) {
        this.userData = statusObject.payload;
      }
    });

    // this.userData = await this.userService.getUser();
    this.subscriptions = this.authService.userProfile?.subscribe((profile) => {
      this.userData = profile;
      if (profile && profile.id) this.userLoggedIn = true;
    });
    this.subscriptions = this.authService.userStatus.subscribe(userStatus => {
      if (userStatus.status === 'active') this.dialogRef.close();
    }) 
    // this.userLoggedIn = await this.userService.isLoggedIn();
    // this.userActivated = await this.userService.isUserActivated(true);

    // if (this.userActivated) {
    //   this.dialogRef.close();
    // }
  }

  public userData!: UserSchema;
  public userLoggedIn!: Boolean;

  public authFormLoading$ = this.isLoadingService.isLoading$({
    key: 'authForm',
  });

  public userActivated!: boolean;
  public _innerRouter$!: BehaviorSubject<AuthInnerRouterParams>;
  public animationOptions: AnimationOptions = {
    path: '../../../../../assets/animation/auth-image.json',
    loop: false,
  };

  public get innerRouterState(): AuthInnerRouterParams {
    return this._innerRouterState;
  }

  startLoading() {
    this.isLoadingService.add({ key: 'authForm' });
  }

  stopLoading() {
    this.isLoadingService.remove({
      key: 'authForm',
    });
  }

  storeUserOnLocalStorage(user: string) {
    if (!!!this.isServer) localStorage.setItem('user', user)
  }

  onAuthentication(authObj: AuthStatusObject) {
    this.isLoadingService.remove({
      key: 'authForm',
    });
    if (!!!this.isServer) this.storeUserOnLocalStorage(JSON.stringify(authObj?.data));
    this.userService.currentUser.next(authObj?.data);
    this.dialogRef.close(authObj);
  }

  googleAuthProcess() {
    this.subscriptions = this.authService.googleAuth().subscribe((status) => {
      setTimeout(() => {
        this.isLoadingService.remove(this.authFormLoading$);
        status.popup?.close();
      }, 20 * 10000);
    });
  }

  swithOtp() {
    this.otp = !this.otp;
  }

  onUserActivation(event: boolean) {
    if (event) {
      this.dialogRef.close({ type: 'userActivated' });
      this.snackbar.open('کاربر با موفقیت تایید شد', '', { duration: 2000 });
    }
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });

    this.isLoadingService.remove({
      key: 'authForm',
    });
  }
}
